/* Copyright (c) 2017 Backpack Health LLC */
/* global document */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { actions as systemNotificationActions } from 'redux/ducks/systemNotification';
import SessionService from '../../apiServices/SessionService';

import { Buttons, Card, Spacer, Inputs, Text } from '../../bphComponents/bundle';

const resendCodeStateNames = {
  SENT: 'SENT',
  SENDING: 'SENDING',
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    onShowError: (apiError) => {
      dispatch(systemNotificationActions.showNotification(apiError.messageKey()));
    },
  };
}

class MfaCodeEntry extends React.Component {
  constructor(props) {
    super(props);

    this.handleMfaCodeChange = this.handleMfaCodeChange.bind(this);
    this.resendCode = this.resendCode.bind(this);
    this.submitCode = this.submitCode.bind(this);
    this.clearCode = this.clearCode.bind(this);
    this.tabEventHandle = this.tabEventHandle.bind(this);

    this.state = {
      displayMobileNumber: props.mobileNumber,
      resendCodeState: resendCodeStateNames.SENT,
      resendTimeout: null,
    };
  }
  UNSAFE_componentWillMount() {
    document.addEventListener('keydown', this.tabEventHandle);
  }
  componentDidMount() {
    SessionService.sendMfaCode(this.props.token, (apiError, res) => {
      if (apiError) {
        this.props.onShowError(apiError);
      } else {
        this.setState({
          displayMobileNumber: res.mobile_number,
        });
      }
    });
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.tabEventHandle);
  }
  submitCode(event) {
    event.preventDefault();
    this.props.submitMfaCode();
  }
  tabEventHandle(event) {
    const key = event.keyCode;
    if (key === 9) {
      this.submitCode(event);
    }
  }
  handleMfaCodeChange(value) {
    this.props.onChangeMfaCode(value);
  }

  resendCode() {
    SessionService.sendMfaCode(this.props.token, (apiError, res) => {
      this.setState({
        displayMobileNumber: res.mobile_number,
      });
    });

    const resendTimeout = setTimeout(() => {
      clearTimeout(this.state.resendTimeout);
      this.setState({
        resendTimeout: null,
        resendCodeState: resendCodeStateNames.SENT,
      });
    }, 5000);

    this.setState({
      resendTimeout,
      resendCodeState: resendCodeStateNames.SENDING,
    });

    if (this.props.onResend) {
      this.props.onResend();
    }
  }

  clearCode() {
    this.props.onChangeMfaCode('');
  }

  render() {
    return !this.props.isWaitingForMfa ? (
      <Redirect to={this.props.cancelMfaRoute} />
    ) : (
      <div className="pg-2fa-mobile-number">
        <Card.CardShape>
          <Card.CardContent>
            <Text.TextSubhead className="font-color-gsMedDark">
              <FormattedMessage
                id="2FACodeEntry.codeSent.message.text"
                values={{ string1: this.state.displayMobileNumber }}
              />
            </Text.TextSubhead>

            <Spacer.Height18 />

            <form ref={ref => (this.form = ref)} onSubmit={this.submitCode}>
              <Inputs.TextInput
                value={this.props.mfaCode}
                type="tel"
                label={<FormattedMessage id="2FACodeEntry.title.text" />}
                name="mobileNumber"
                onChange={this.handleMfaCodeChange}
                onFocus={this.props.onFocus}
                initialFocus
                isInvalid={!!this.props.errorMessage}
                invalidHint={this.props.errorMessage}
                isClearable
                clearValue={this.clearCode}
              />
            </form>

            <Spacer.Height18 />

              {this.state.resendCodeState === resendCodeStateNames.SENT ? (
                <Buttons.ButtonLink onClick={this.resendCode} className="font-color-profile">
                  <Text.TextFootnote>
                    <FormattedMessage id="2FACodeEntry.resendCode.button.label" />
                  </Text.TextFootnote>
                </Buttons.ButtonLink>
              ) : (
                <Text.TextFootnote isItalic>
                  <FormattedMessage id="2FACodeEntry.resendingCode.message.text" />
                </Text.TextFootnote>
              )}
          </Card.CardContent>
        </Card.CardShape>

      </div>
    );
  }
}
MfaCodeEntry.propTypes = {
  isWaitingForMfa: PropTypes.bool,
  token: PropTypes.string.isRequired,
  cancelMfaRoute: PropTypes.string,
  errorMessage: PropTypes.any,
  mfaCode: PropTypes.string,
  mobileNumber: PropTypes.string,
  submitMfaCode: PropTypes.func,
  onChangeMfaCode: PropTypes.func,
  onFocus: PropTypes.func,
  onResend: PropTypes.func,
  onShowError: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(MfaCodeEntry);
